import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { OrganizationService } from './services/organization.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

import { OrganizationDetailsComponent } from './components/organization-details/organization-details.component';
import { PaypointService } from './services/paypoint.service';
import { PaypointComponent } from './components/paypoint/paypoint.component';
import { ProcessPaymentComponent } from './components/process-payment/process-payment.component';
import { BasisTheoryService } from './services/basistheory';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { WalletComponent } from './components/wallet/wallet.component';
import { CreditCardFormComponent } from './components/wallet/credit-card-form/credit-card-form.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TransactionTableComponent } from './components/transactions/transaction-table/transaction-table.component';
import { TransactionDashboardComponent } from './components/transactions/dashboard/dashboard.component';
import { VoidModalComponent } from './components/transactions/void-modal/void-modal.component';
import { TransactionDetailsModalComponent } from './components/transactions/transaction-details-modal/transaction-details-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PaymentCodePipe } from './pipes/payment-code.pipe';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { AddPaypointComponent } from './components/paypoint/add-paypoint/add-paypoint.component';
import { ViewPaypointsComponent } from './components/paypoint/view-paypoints/view-paypoints.component';
import { ViewRoutingRulesComponent } from './components/paypoint/view-routing-rules/view-routing-rules.component';
import { AddRoutingRuleComponent } from './components/paypoint/add-routing-rule/add-routing-rule.component';
import { PaypointItemComponent } from './components/paypoint/view-paypoints/paypoint-item/paypoint-item.component';
import { PaypointCodePipe } from './pipes/paypoint-code.pipe';
import { AddPaymentDialogComponent } from './components/wallet/add-payment-dialog/add-payment-dialog.component';
import { RemoveConfirmationDialogComponent } from './components/wallet/remove-confirmation-dialog/remove-confirmation-dialog.component';
import { BankAccountFormComponent } from './components/wallet/bank-account/bank-account-form.component';
import { MatMenuModule } from '@angular/material/menu';
import { PartialsModule } from '../../views/partials/partials.module';
import { SharedModule } from '../../shared/shared.module';
import { PaymentDetailsTabComponent } from './components/process-payment/payment-details-tab/payment-details-tab.component';
import { PaymentMethodTabComponent } from './components/process-payment/payment-method-tab/payment-method-tab.component';
import { PaymentPreviewTabComponent } from './components/process-payment/payment-preview-tab/payment-preview-tab.component';
import { PaymentProcessService } from './services/payment-process.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BridgepayRoutingModule } from './bridgepay-routing.module';
import { CoreModule } from '../core.module';
import { InlineSVGModule } from 'ng-inline-svg';
import { NgxPermissionsModule } from 'ngx-permissions';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { transactionsHistoryReducer } from './store/reducers/transaction-history.reducer';
import { TransactionHistoryEffects } from './store/effects/transaction-history.effects';
import { TransactionsInsightsComponent } from './components/transactions/transactions-insights/transactions-insights.component';
import { TranslateModule } from '@ngx-translate/core';
import { SelectAnotherDefaultMethodComponent } from './components/wallet/select-another-default-method/select-another-default-method.component';
import { WalletSelectionPaymentComponent } from './components/process-payment/wallet-selection-payment/wallet-selection-payment.component';
@NgModule({
  declarations: [
    OrganizationDetailsComponent,
    PaypointComponent,
    ProcessPaymentComponent,
    WalletComponent,
    CreditCardFormComponent,
    TransactionTableComponent,
    TransactionsInsightsComponent,
    VoidModalComponent,
    TransactionDashboardComponent,
    TransactionDetailsModalComponent,
    PaymentCodePipe,
    PaypointCodePipe,
    AddPaypointComponent,
    ViewPaypointsComponent,
    ViewRoutingRulesComponent,
    AddRoutingRuleComponent,
    PaypointItemComponent,
    AddPaymentDialogComponent,
    RemoveConfirmationDialogComponent,
    SelectAnotherDefaultMethodComponent,
    BankAccountFormComponent,
    PaymentCodePipe,
    PaymentDetailsTabComponent,
    PaymentMethodTabComponent,
    PaymentPreviewTabComponent,
    WalletSelectionPaymentComponent,
  ],
  imports: [
    BridgepayRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatListModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatRadioModule,
    FormsModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatCardModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatTooltipModule,
    MatCardModule,
    MatToolbarModule,
    RouterModule,
    MatMenuModule,
    PartialsModule,
    SharedModule,
    MatSlideToggleModule,
    CoreModule,
    InlineSVGModule,
    NgxPermissionsModule,
    StoreModule.forFeature('transactionsHistory', transactionsHistoryReducer),
    EffectsModule.forFeature([TransactionHistoryEffects]),
    TranslateModule,
  ],
  entryComponents: [
    OrganizationDetailsComponent,
    PaypointComponent,
    WalletComponent,
    CreditCardFormComponent,
    ProcessPaymentComponent,
    VoidModalComponent,
    TransactionDetailsModalComponent,
    VoidModalComponent,
    AddPaymentDialogComponent,
    BankAccountFormComponent,
    CreditCardFormComponent,
    RemoveConfirmationDialogComponent,
    SelectAnotherDefaultMethodComponent,
  ],
  exports: [
    OrganizationDetailsComponent,
    PaypointComponent,
    WalletComponent,
    CreditCardFormComponent,
    ProcessPaymentComponent,
    VoidModalComponent,
    TransactionTableComponent,
    TransactionsInsightsComponent,
    TransactionDashboardComponent,
    PaymentCodePipe,
    AddPaymentDialogComponent,
    RemoveConfirmationDialogComponent,
    SelectAnotherDefaultMethodComponent,
    BankAccountFormComponent,
  ],
  providers: [OrganizationService, PaypointService, BasisTheoryService, PaymentProcessService],
})
export class BridgePayModule {}
